export default __webpack_public_path__ + "static/media/paw.4513dcdd.png";